// Account-type identifier shared across friend profiles & lists.
// 3 tiers determined by role first, then date-of-birth / age:
//   Adult  (18+, or role parent/adult/guardian)  -> blue ring + 🛡
//   Teen   (13-17)                                -> teal ring + ★
//   Kid    (<=12, or child_explorer)              -> amber ring + 🧒
// Color alone isn't accessible, so the friend PROFILE also shows a text chip.

const ADULT_ROLES = new Set(["parent", "adult", "guardian", "co_parent", "coparent", "admin", "super_admin", "teacher"]);

function ageFromBirthdate(bd) {
  if (!bd) return null;
  const d = new Date(bd);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let a = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) a--;
  return a >= 0 && a < 120 ? a : null;
}

export function accountTier(friend = {}) {
  // Prefer a tier the backend already computed (keeps the badge and any
  // "please review" reason perfectly in sync on the Parent Review panel).
  if (friend.tier && TIERS[friend.tier]) return TIERS[friend.tier];
  const role = (friend.role || "").toLowerCase();
  const age = typeof friend.age === "number" ? friend.age : ageFromBirthdate(friend.birthdate);
  let tier;
  if (ADULT_ROLES.has(role)) tier = "adult";
  else if (age != null) tier = age >= 18 ? "adult" : age >= 13 ? "teen" : "kid";
  else if (role === "teen") tier = "teen";
  else if (role === "child_explorer" || role === "kid" || role === "child") tier = "kid";
  else tier = "kid"; // safe default on a kids' platform
  return TIERS[tier];
}

export const TIERS = {
  kid: { tier: "kid", label: "Kid", chip: "Kid", pip: "🧒", ring: "#F59E0B", ringClass: "ring-amber-400", bg: "rgba(245,158,11,0.15)", border: "rgba(245,158,11,0.45)", color: "#FDE68A" },
  teen: { tier: "teen", label: "Teen", chip: "Teen", pip: "⭐", ring: "#2DD4BF", ringClass: "ring-teal-400", bg: "rgba(45,212,191,0.15)", border: "rgba(45,212,191,0.45)", color: "#99F6E4" },
  adult: { tier: "adult", label: "Grown-up", chip: "Grown-up", pip: "🛡️", ring: "#3B82F6", ringClass: "ring-blue-400", bg: "rgba(59,130,246,0.15)", border: "rgba(59,130,246,0.45)", color: "#BFDBFE" },
};
